export default class CertificationMeta {
    static async getExamDescription(container: string) {
        const response = await fetch(`https://cdn.testout.com/certification-meta-v2/${container}/exam-description.txt`);
        if (response.ok) {
            let buffer = await response.arrayBuffer();

            let codePage = undefined;
            if (buffer.byteLength >= 4) {
                const codePageArray = new Uint8Array(buffer.slice(0, 4));
                if (codePageArray[0] === 239 && codePageArray[1] === 187 && codePageArray[2] === 191)
                    codePage = 'utf-8';
                else if (codePageArray[0] === 254 && codePageArray[1] === 255)
                    codePage = 'utf-16be';
                else if (codePageArray[0] === 255 && codePageArray[1] === 254)
                    codePage = 'utf-16le';
                else if (codePageArray[0] === 0 && codePageArray[1] === 0 && codePageArray[2] === 254 && codePageArray[3] === 255)
                    codePage = 'utf-32be';
                else if (codePageArray[0] === 255 && codePageArray[1] === 254 && codePageArray[2] === 0 && codePageArray[3] === 0)
                    codePage = 'utf-32le';
                else if (codePageArray[0] === 43 && codePageArray[1] === 47 && codePageArray[2] === 118)
                    codePage = 'utf-7';
                else if (codePageArray[0] === 247 && codePageArray[1] === 100 && codePageArray[2] === 76)
                    codePage = 'utf-1';
            }

            return new TextDecoder(codePage).decode(buffer);
        }
    }

    static async getExamSkills(container: string) {
        const response = await fetch(`https://cdn.testout.com/certification-meta-v2/${container}/certification.xml`);
        if (response.ok) {
            let xmlText = await response.text();
            let parser = new DOMParser();
            let xmlDoc = parser.parseFromString(xmlText, "text/xml");

            let result = [] as Array<{domain: string, objectives: Array<string>}>;

            let certs = xmlDoc.evaluate('//Certification', xmlDoc, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
            for (let i = 0; i < certs.snapshotLength; i++) {
                let title = (certs.snapshotItem(i) as Element).getAttribute("en-us");
                if (title != null) {
                    let isPro = (title + ' ').match(/(\s|^)((Pro)|(Competency))(\s|$)/) != null;
                    if (isPro) {
                        //@ts-ignore
                        let domains = xmlDoc.evaluate('Domain', certs.snapshotItem(i), null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
                        for (let i = 0; i < domains.snapshotLength; i++) {
                            let title = (domains.snapshotItem(i) as Element).getAttribute("en-us");
                            if (title != null) {
                                let d = { domain: title, objectives: [] as Array<string>};
                                result.push(d);

                                //@ts-ignore
                                let objectives = xmlDoc.evaluate('Objective', domains.snapshotItem(i), null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
                                for (let i = 0; i < objectives.snapshotLength; i++) {
                                    let title = (objectives.snapshotItem(i) as Element).getAttribute("en-us");
                                    if (title != null)
                                        if(d.objectives[i - 1] !== title)
                                            d.objectives.push(title);
                                }
                            }
                        }
                    }
                }
            }

            return result.length > 0 ? result : undefined;
        }
    }
}